export const ForgetPasswordConstraints = ()=>{

    const forgetPassword = () => {
        return (
            {
                email:"",
            }
        )
    }
    const constraintData =()=>{
        return({
            loadingForgetPassword:false,
            passwordSent:false,
            errMessage:"",
        })
    }

    return({
        forgetPassword,
        constraintData
    })

}
